var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "#B9DCFF",
    stroke: "#B9DCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4598 15.2615C24.1771 13.8038 23.0693 12.492 23.0693 10.6845C23.0693 9.75167 23.5066 8.32321 24.1479 7.33203C24.1479 7.33203 21.4659 7.91508 19.7459 10.014C18.1426 11.9964 16.5683 15.4364 16.8307 20.1007C15.8687 18.9346 14.7317 16.3401 14.9358 14.5035C14.9358 14.5035 11.0002 18.614 11.0002 23.599C11.0002 28.5549 15.0524 32.6654 20.0666 32.6654C25.0516 32.6654 29.133 28.5549 29.133 23.5699C29.1038 19.4594 27.1798 17.2147 25.4598 15.2615Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4541 29.8984C16.3931 29.1696 14.4982 26.5459 14.2067 25.3798",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.1746,
    y1: 28.8841,
    x2: 19.5959,
    y2: 28.3256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA0029"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.ffc6d1e3.svg";
export { ForwardRef as ReactComponent };